import SspList from 'common/pages/ssp/SspList.tsx'

export const SspListAdmin = (props: any) => <SspList {...props} mode={props.mode} admin />